import { WeGoConfig } from './../../shared/config';
export class EventViewerModel {
  id: number;
  category: string;
  eventName: string;
  eventData: string;
  moment: string;
  user: string;
}

export class EventViewerSearchModel {
  filter: string = '';
  fromDate: string;
  toDate: string;
  searchField: string;
  totalItems: number = 0;
  pageNo: number = 1;
  maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
  record: number = WeGoConfig.GRID_MAX_DATA_SIZE;
  sortType: string = "";
  sortReverse: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/event-viewer/models/event-viewer.model.ts